.img {
  width: 100%;
}